module.exports = __webpack_public_path__ + "static/media/IMG-7.317fe27c.jpg";